import axiosClient from '@/services/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

const fetchFrequentlyBoughtTogether = createAsyncThunk(
  'products/fetchFrequentlyBoughtTogether',
  async ({ slug }, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        `/api/products/${slug}/frequently-bought-together`,
        {
          params: { limit: 10, page: 1 },
        },
      );

      return response?.data?.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  },
);

export default fetchFrequentlyBoughtTogether;
